module.exports = __webpack_public_path__ + "static/media/shoe_02.fb455c03.jpg";